import React from "react";

import { Outlet, useLocation } from "react-router-dom";

import Routers from "../constants/routers";
import "../styles/AdminViewportList.css";
import "../styles/RemainingAdminViewportLists.css";
import Header from "./Header";
import "./Layout.css";
import Sidebar from "./Sidebar";
import StickyTableHeaders from "./StickyTableHeaders";
import { isAdminViewportList } from "./adminViewportLists";

const Layout: React.FC = () => {
  const { pathname } = useLocation();
  const isContractList = pathname.replace(/\/$/, "") === Routers.Contracts;
  const isViewportList = isAdminViewportList(pathname);

  return (
    <div
      className={`layout${isContractList ? " layout--contract-list" : ""}${isViewportList ? " layout--admin-viewport-list" : ""}`}
    >
      <Header />
      <div className="layout-content">
        <Sidebar />
        <main className="main-content">
          <Outlet />
        </main>
      </div>
      <StickyTableHeaders />
    </div>
  );
};

export default Layout;
